module.exports = __webpack_public_path__ + "static/media/postgresql.ce699f41.svg";